<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		
		<el-card class="box-card order-list">
			<div slot="header" class="clearfix"><span>品牌授权信息</span></div>

			<el-tabs v-model="orderStatus" @tab-click="handleClick">
				<el-tab-pane label="全部授权" name="all"></el-tab-pane>
				<el-tab-pane label="申请中" name="sqz"></el-tab-pane>
				<el-tab-pane label="已授权" name="ysq"></el-tab-pane>
				<el-tab-pane label="已过期" name="ygq"></el-tab-pane>
			</el-tabs>

			<div v-loading="loading">
				<nav>
					<li>授权方</li>
					<li>被授权方</li>
					<li>授权品牌</li>
					<li>授权时间</li>
					<li>操作</li>
				</nav>

				<div class="list" v-if="orderList.length > 0">
					<div class="item" v-for="(brandItem, orderIndex) in orderList" :key="orderIndex">
						<div class="head">
							<span class="order-no">序号：{{ brandItem.collect_id }}-{{brandItem.brand_id}}</span>
							<span class="create-time" style="float: right;">申请时间：{{ $util.timeStampTurnTime(brandItem.create_time) }}</span>
						</div>
						<ul>
							<li>
								<span>{{ brandItem.sqf_name }}</span>
							</li>
							<li>
								<span>{{ brandItem.bsqf_name }}</span>
							</li>
							<li>
								<span>{{ brandItem.brand_name }}</span>
							</li>
							
							<li class="shli" v-if="brandItem.status == 1" >
								<span>{{ $util.timeStampTurnTimeday(brandItem.sq_time) }}</span>
								<span>---</span>
								<span>{{ $util.timeStampTurnTimeday(brandItem.end_time) }}</span>
							</li>
							<li v-else style="text-align: center;">
								<span>---</span>
							</li>
							
							<li class="shli_xz" v-if="brandItem.status == 1" >
								<template>
									<el-button type="success" size="mini" plain  @click="operation('authorPower', brandItem)">
										<template>
											下载授权书
										</template>
									</el-button>
								</template>
								<template v-if="brandItem.squrl!=''&&brandItem.squrl!=NULL">
									<div>
									<el-button type="success" size="mini" plain  @click="operation_href('squrl', brandItem.squrl)">
										<template>
											下载授权链路
										</template>
									</el-button>
									</div>
								</template>
								<template v-if="brandItem.ppzl!=''&&brandItem.squrl!=NULL">
									<el-button type="success" size="mini" plain  @click="operation_href('ppzl', brandItem.ppzl)">
										<template>
											下载品牌资料
										</template>
									</el-button>
								</template>
							</li>
							
							<li v-else style="text-align: center;">
								<template>
									<el-button v-if="brandItem.status == 0" type="info" size="mini" plain>
										<template>
											申请中
										</template>
									</el-button>									
									<el-button v-else type="primary" size="mini" plain>
										<template>
											已过期
										</template>
									</el-button>
								</template>
							</li>
						</ul>
					</div>
				</div>
				<div v-else-if="!loading && orderList.length == 0" class="empty-wrap">暂无相关订单</div>
			</div>
			<div class="pager">
				<el-pagination 
					background 
					:pager-count="5" 
					:total="total" 
					prev-text="上一页" 
					next-text="下一页" 
					:current-page.sync="currentPage" 
					:page-size.sync="pageSize" 
					@size-change="handlePageSizeChange" 
					@current-change="handleCurrentPageChange" 
					hide-on-single-page
				></el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { apiBrandList } from '@/api/member/brand_collect';
export default {
	name: 'order_list',
	components: {},
	data: () => {
		return {
			orderStatus: 'all',
			loading: true,
			orderList: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			yes: true
		};
	},
	created() {
		this.orderStatus = this.$route.query.status || 'all';
		this.getOrderList();
	},
	computed: {
		...mapGetters(['defaultGoodsImage'])
	},
	mounted() {
		let self = this;
		setTimeout(function() {
			self.yes = false
		}, 300)
	},
	methods: {
		handleClick(tab, event) {
			this.currentPage = 1;
			this.orderStatus = tab.name;
			this.refresh();
		},
		getOrderList() {
			apiBrandList({
				page: this.currentPage,
				page_size: this.pageSize,
				status: this.orderStatus
			})
				.then(res => {
					let list = [];
					if (res.code == 0 && res.data) {
						list = res.data.list;
						this.total = res.data.count;
					}
					this.orderList = list;
					this.loading = false;
				})
				.catch(res => {
					this.loading = false;
				});
		},
		handlePageSizeChange(size) {
			this.pageSize = size;
			this.refresh();
		},
		handleCurrentPageChange(page) {
			this.currentPage = page;
			this.refresh();
		},
		refresh() {
			this.loading = true;
			this.getOrderList();
		},
		operation_href(action, weburl) {
			window.open(weburl, '_blank')
			//window.location.href = weburl;
		},
		operation(action, orderData) {
			switch (action) {
				case 'authorPower': //评价
					this.$router.pushToTab({ path: '/member/author', query: { collect_id: orderData.collect_id } });
					break;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.box {
	width: 100%;
	position: relative;
}

.null-page {
	width: 100%;
	height: 730px;
	background-color: #FFFFFF;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
}

.order-list {
	nav {
		overflow: hidden;
		padding: 10px 0;
		background: #fff;
		margin-bottom: 10px;
		border-bottom: 1px solid #eeeeee;
		li {
			float: left;
			width: 20%;
			&:nth-child(4) {
				text-align: center;
			}
			
			&:nth-child(5) {
				text-align: center;
			}
		}
	}
	.list {
		.item {
			margin-bottom: 20px;
			border: 1px solid #eeeeee;
			border-top: 0;
			.head {
				padding: 8px 10px;
				background: #f7f7f7;
				font-size: 12px;

				.create-time {
					margin-right: 10px;
				}

				border-bottom: 1px solid #eeeeee;
				a {
					margin: 0 10px 0 20px;
				}

				.order-type {
					margin-left: 30px;
				}
			}
		}
		ul {
			background-color: #fff;
			padding: 10px;
			overflow: hidden;
			li {
				float: left;
				line-height: 90px;
				width: 20%;
				
				&:nth-child(1) {
					margin-top: 25px;
					line-height: 30px;
				}
				&:nth-child(2) {
					margin-top: 25px;
					line-height: 30px;
				}
				&:nth-child(3) {
					margin-top: 25px;
					line-height: 30px;
				}
				
				span{
					padding: 0px 15px 0px 0px;
				}
				
				&:nth-child(6) {
					line-height: initial;
					button {
						margin-left: 0;
						margin-bottom: 10px;
						&:last-child {
							margin-bottom: 0;
						}
					}
				}
			}
			.shli {
				text-align: center;
				line-height: 29px;	
				span{ display: block;
					width: 100%; text-align: center;
				}
			}
			.shli_xz {
				text-align: -webkit-center;
				line-height: initial;	
				button{ display: block;
					margin: 3px auto;
					width: 100px; text-align: -webkit-center;
				}
			}
		}
	}
	.empty-wrap {
		text-align: center;
		padding: 10px;
	}
}
</style>